import {FC} from 'react';
import block from 'bem-cn-lite';
import {Button, Modal, Text} from '@gravity-ui/uikit';
import {POLICY_CONSENT_KEY} from '@services/hasPolicyConsent';

import './ModalBannerPolicy.scss';

const b = block('modal-banner-policy');

interface ModalBannerPolicyProps {
    visibility: boolean;
    stateModal: (value: boolean) => void;
}

export const ModalBannerPolicy: FC<ModalBannerPolicyProps> = ({visibility, stateModal}) => {
    const onAccept = () => {
        try {
            localStorage.setItem(POLICY_CONSENT_KEY, 'accepted');
        } catch {}
        stateModal(false);
    };

    return (
        <Modal open={visibility} className={b()}>
            <Text variant="subheader-3">Согласие на обработку персональных данных</Text>

            <div className={b('container-text')}>
                <Text variant="body-2">
                    Я даю согласие ООО «Авто-Транзит» на обработку моих персональных данных в
                    соответствии с Политикой обработки персональных данных, размещённой на сайте
                    https://atez.ru/
                </Text>
                <Text variant="body-2">
                    Согласие действует до момента его отзыва путем направления уведомления по адресу
                    электронной почты: avtoem@zapnsk.ru
                </Text>
            </div>

            <div className={b('accept')}>
                <Button size="l" view="action" onClick={onAccept}>
                    Согласен
                </Button>
            </div>
        </Modal>
    );
};
